import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrinter = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M6 3h12v3h3v11h-4v-5H7v5H3V6h3zm1 3h10V4H7z" }),
		/* @__PURE__ */ _jsx("rect", {
			x: 9,
			y: 14
		}),
		/* @__PURE__ */ _jsx("path", { d: "M9 17h6v1H9zM6 16h1v5H6z" }),
		/* @__PURE__ */ _jsx("path", { d: "M6 20h12v1H6z" }),
		/* @__PURE__ */ _jsx("path", { d: "M17 16h1v5h-1z" })
	]
});
export default SvgPrinter;
